import DatePicker from './DatePicker';
import FreeText from './FreeText';
import MultiText from './MultiText';
import NumericField from './NumericField';
import SelectYear from './SelectYear';
import RadioOption from './RadioOption';
import TextArea from './TextArea';

import { IQuestionOption, TQuestionType } from '../../../constants/types';

const componentMap: Record<
  TQuestionType,
  (props: Omit<IQuestionOption, 'questionType'>) => JSX.Element
> = {
  radio: ({ value, options, setAnswer }) => (
    <RadioOption value={value} options={options} setAnswer={setAnswer} />
  ),
  textField: ({ value, setAnswer, question }) => (
    <FreeText value={value} setAnswer={setAnswer} question={question} />
  ),
  numericField: ({ value, setAnswer, question }) => (
    <NumericField value={value} setAnswer={setAnswer} question={question} />
  ),
  date: ({ value, setAnswer }) => (
    <DatePicker value={value as Date | null} setAnswer={setAnswer} />
  ),
  textarea: ({ question, value, setAnswer }) => (
    <TextArea question={question} value={value} setAnswer={setAnswer} />
  ),
  multiText: ({ question, setAnswer }) => (
    <MultiText question={question} setAnswer={setAnswer} />
  ),
  selectYear: ({ value, setAnswer, question, childQuestion = false }) => (
    <SelectYear
      value={value as string}
      setAnswer={setAnswer}
      question={question}
      childQuestion={childQuestion}
    />
  ),
};

const QuestionOption = (props: IQuestionOption) => {
  const { questionType, childQuestion = false } = props;
  const Component = componentMap[questionType];

  if (!Component) {
    return <div>Unsupported question type</div>;
  }

  return <Component {...props} childQuestion={childQuestion} />;
};

export default QuestionOption;
